import React from 'react'
import styled from 'styled-components'
import Hero from './Hero'
import Tokenomics from './Tokenomics'
import RolesAndEntities from './RolesAndEntities'
import BuyAndStore from './BuyAndStore'
import Layout from '~shared/Layout'
import Spacer from '~shared/Spacer'
import Divider from '~shared/Divider'

const UnstyledDataToken = (props) => (
    <Layout {...props}>
        <Spacer head="2rem,5rem,12.5rem">
            <Hero />
        </Spacer>
        <Tokenomics head="6.5rem,9rem,10.5rem" />
        <RolesAndEntities head="4rem,5rem,9.5rem" tail="4rem,6rem,8.5rem" />
        <Divider />
        <BuyAndStore head="4rem,6rem,10.5rem" tail="8rem,8rem,10.5rem" />
    </Layout>
)

const DataToken = styled(UnstyledDataToken)`
    color: #0C009A;
`

export default DataToken
